import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.1),
      padding: theme.spacing(1),
    },
  },
  round: {
    borderRadius: '10px',
  },
  chip: {
    fontWeight: 'bold',
    color: '#6F6F6F',
    justifyContent: 'space-around',
  },
  noborder: {
    border: 'none',
  },
}))

export { useStyles }
